<template>
  <div v-if="inputValue">
    <MasterMultipleAreaBase
      v-model="inputValue"
      :title="
        $t('sale.sale_customer') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
      :pageData="pageData"
      @complete="complete()"
      @clicksubTextButton="addRecipientInputForm()"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="mx-10 my-3">
            <v-col cols="5" class="mr-16">
              <InputFormNew
                v-model="inputData.customerInfoLine1"
                :detail="dynamicItems.customerInfoLine1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <!-- 顧客分類 -->
                <template #customerCategoryName="{ item }">
                  <v-select
                    v-model="item.customerCategoryId"
                    item-text="label"
                    item-value="value"
                    :items="
                      createCustomerCategorySelectBoxValueFrom(
                        customerCategoryList
                      )
                    "
                    dense
                    outlined
                    class="original-selectbox"
                    hide-details
                    :placeholder="$t('common.input_please-select')"
                    :height="inputFormStyle.inputItemHeight"
                  />
                </template>

                <!-- 掛け率 -->
                <template #rateAccount="{ item }">
                  <v-row align="center">
                    <v-col cols="9">
                      <v-text-field
                        v-model="item.rateAccount"
                        placeholder="0"
                        outlined
                        dense
                        hide-details
                        :height="inputFormStyle.inputItemHeight"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="2" class="pa-0">%</v-col>
                  </v-row>
                </template>

                <!-- 自動出庫倉庫（ネクストエンジン連携用） -->
                <template #autoShipStorage="{ item }">
                  <v-select
                    v-model="item.autoShipStorageId"
                    item-text="label"
                    item-value="value"
                    :items="
                      createAutoShipStorageSelectBoxValueFrom(
                        autoShipStorageList
                      )
                    "
                    dense
                    outlined
                    class="original-selectbox"
                    hide-details
                    :placeholder="$t('common.input_please-select')"
                    :height="inputFormStyle.inputItemHeight"
                  />
                </template>
              </InputFormNew>
            </v-col>
            <v-col cols="5">
              <InputFormNew
                v-model="inputData.customerInfoLine2"
                :detail="items.customerInfoLine2"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[1].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="mx-10 my-3">
            <v-col cols="5" class="mr-16">
              <InputFormNew
                v-model="inputData.invoiceInfoLine1"
                :detail="items.invoiceInfoLine1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              />
            </v-col>
            <v-col cols="5">
              <InputFormNew
                v-model="inputData.invoiceInfoLine2"
                :detail="items.invoiceInfoLine2"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <!-- 郵便番号 -->
                <template #billingPostalCode="{ item }">
                  <PostalCodeArea
                    v-model="item.billingPostalCode"
                    :height="inputFormStyle.inputItemHeight"
                    :countryId="item.country.value"
                    @click="getAddressFromInvoiceInfoPostalCode"
                  />
                </template>
              </InputFormNew>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[2].name]>
        <v-container fluid class="pa-0">
          <v-row v-if="!inputData.recipientList.length" no-gutters class="ma-7">
            <v-col class="text-center">
              {{ $t('user.user_recipient-is-not-set') }}
            </v-col>
          </v-row>
          <li
            v-for="recipientItem in inputData.recipientList"
            :key="recipientItem.recipientId"
          >
            <v-row no-gutters class="ml-10">
              <v-col cols="5" class="mr-16">
                <InputFormNew
                  v-model="recipientItem.recipientInfoLine1"
                  :detail="items.recipientInfoLine1"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                  :master-data="recipients"
                />
              </v-col>
              <v-col cols="5" class="mr-10">
                <InputFormNew
                  v-model="recipientItem.recipientInfoLine2"
                  :detail="items.recipientInfoLine2"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                  <!-- 郵便番号 -->
                  <template #recipientPostalCode="{ item }">
                    <PostalCodeArea
                      v-model="item.recipientPostalCode"
                      :height="inputFormStyle.inputItemHeight"
                      :countryId="item.country.value"
                      @click="getAddressFromRecipientPostalCode($event, item)"
                    />
                  </template>
                </InputFormNew>
              </v-col>
              <v-col class="deleteItemCol d-flex justify-center align-center">
                <div class="">
                  <NormalTextButton
                    :text="$t('common.input_delete')"
                    @click.native="deleteRecipientInfo(recipientItem)"
                  />
                </div>
              </v-col>
            </v-row>
            <v-divider> </v-divider>
          </li>
        </v-container>
      </template>
    </MasterMultipleAreaBase>
  </div>
</template>
<script>
import MasterMultipleAreaBase from '../MasterMultipleAreaBase'
import {
  InputFormNew,
  NormalTextButton,
  PostalCodeArea
} from '@/components/items'
import { mapActions, mapGetters } from 'vuex'
import { countryCallingCodeUtil, countryUtil } from '@/util'

export default {
  components: {
    MasterMultipleAreaBase,
    InputFormNew,
    NormalTextButton,
    PostalCodeArea
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    customerData: {
      type: Object,
      require: false,
      default: () => ({
        recipients: []
      })
    },
    editMode: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data: () => ({
    pageData: [{}, {}, {}],
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9,
      inputItemHeight: '32px'
    },
    inputData: {
      recipientList: [],
      isNeShop: false
    },
    // autoShipStorageの定義をここから削除
    items: {
      customerInfoLine1: [
        {
          name: 'rep',
          text: 'sale.sale_customer-name',
          required: true
        },
        {
          name: 'alphabet',
          text: 'user.user_alphabet_pinyin'
        },
        {
          name: 'organizationName',
          text: 'user.user_organization-name'
        },
        {
          name: 'sectionName',
          text: 'user.user_department-name'
        },
        {
          name: 'customerCategoryName',
          text: 'common.input_customer-category',
          cols: Math.ceil(5),
          required: true
        },
        {
          name: 'paymentCriteria',
          text: 'common.input_payment-criteria',
          cols: Math.ceil(5)
        },
        {
          name: 'rateAccount',
          text: 'sale.sale_rate-account',
          cols: Math.ceil(5),
          description: 'sale.sale_rate-account-description',
          required: true
        }
      ],
      customerInfoLine2: [
        {
          name: 'phone',
          text: 'common.input_phone-number',
          component: 'PhoneNumberInput'
        },
        {
          name: 'mailAddress',
          text: 'common.input_email'
        },
        {
          name: 'wechatId',
          text: 'common.input_we-chat-id'
        },
        {
          name: 'shopName',
          text: 'jd.jd_store-name'
        },
        {
          name: 'url',
          text: 'common.input_url'
        },
        {
          name: 'customerNote',
          text: 'common.input_remarks'
        },
        {
          name: 'isEnabled',
          text: 'product.product_display-setting',
          component: 'CheckEnabled'
        }
      ],
      invoiceInfoLine1: [
        {
          name: 'billingOrganizationName',
          text: 'user.user_organization-name'
        },
        {
          name: 'billingSectionName',
          text: 'user.user_department-name'
        },
        {
          name: 'billingName',
          text: 'common.input_name'
        },
        {
          name: 'billingPhone',
          text: 'common.input_phone-number',
          component: 'PhoneNumberInput'
        }
      ],
      invoiceInfoLine2: [
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil(5),
          component: 'SelectCountry'
        },
        {
          name: 'billingPostalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil(5)
        },
        {
          name: 'billingRegion',
          text: 'common.input_region',
          cols: Math.ceil(5),
          component: 'SelectRegion'
        },
        {
          name: 'billingAddress1',
          text: 'common.input_address_1'
        },
        {
          name: 'billingAddress2',
          text: 'common.input_address_2'
        }
      ],
      recipientInfoLine1: [
        {
          name: 'recipientName',
          text: 'common.input_name',
          required: true
        },
        {
          name: 'recipientOrganizationName',
          text: 'user.user_company-name',
          required: true
        },
        {
          name: 'recipientPhone',
          text: 'common.input_phone-number',
          required: true,
          component: 'PhoneNumberInput'
        },
        {
          name: 'recipientSortNumber',
          text: 'common.input_sort-number',
          cols: Math.ceil(5),
          required: true,
          component: 'SelectSortNumber'
        },
        {
          name: 'recipientNote',
          text: 'common.input_remarks'
        }
      ],
      recipientInfoLine2: [
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil(5),
          required: true,
          component: 'SelectCountry'
        },
        {
          name: 'recipientPostalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil(5)
        },
        {
          name: 'recipientRegion',
          text: 'common.input_region',
          cols: Math.ceil(5),
          required: true,
          component: 'SelectRegion'
        },
        {
          name: 'recipientAddress1',
          text: 'common.input_address_1',
          required: true
        },
        {
          name: 'recipientAddress2',
          text: 'common.input_address_2'
        }
      ]
    },
    // autoShipStorageの定義を分離
    autoShipStorageItem: {
      name: 'autoShipStorage',
      text: 'nextengine.nextengine_auto-ship-storage',
      cols: Math.ceil(5),
      description: 'nextengine.nextengine_auto-ship-storage-description',
      required: false
    },
    customerCategoryList: [],
    autoShipStorageList: []
  }),

  methods: {
    ...mapActions('Customer', ['registerCustomer', 'editCustomer']),
    ...mapGetters('Customer', ['getCustomerListFromState']),
    ...mapGetters('Common', [
      'getCustomerCategoryFromState',
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState'
    ]),
    ...mapActions('Common', [
      'getCustomerCategoryListFromApi',
      'getCountryListFromApi'
    ]),
    ...mapActions('Storage', ['getStorageListFromApi', 'registerEditStorage']),
    ...mapGetters('Storage', ['getStorageListFromState']),

    async getCustomerCategoryList() {
      await this.getCustomerCategoryListFromApi({
        isHideUnusedCustomerCategory: 1
      })
      this.customerCategoryList = this.getCustomerCategoryFromState()
    },
    async getStorageList() {
      await this.getStorageListFromApi({
        isEnabled: 1
      })
      this.autoShipStorageList = this.getStorageListFromState()
    },

    setCountryCallingCode(countryId) {
      return this.editMode
        ? countryCallingCodeUtil.getPhoneNumberInfoById(countryId)
        : this.getCountryCallingCodeJpFromState()
    },
    setCountryId(countryId) {
      return this.editMode
        ? countryUtil.getCountryIdInfo(countryId)
        : this.getCountryJpFromState()
    },
    createCustomerCategorySelectBoxValueFrom(customerCategoryList) {
      return customerCategoryList.map((ele) => {
        return {
          value: ele.customerCategoryId,
          label: ele.name
        }
      })
    },
    // 自動出庫倉庫のセレクトボックス用
    createAutoShipStorageSelectBoxValueFrom(storageList) {
      return storageList.map((ele) => {
        return {
          value: ele.storageId,
          label: ele.name
        }
      })
    },
    // 請求書情報の郵便番号自動入力
    getAddressFromInvoiceInfoPostalCode(address) {
      this.inputData.invoiceInfoLine2.billingRegion =
        countryUtil.getRegionInfoByName(
          this.inputData.invoiceInfoLine2.country.value,
          address.region
        )
      this.inputData.invoiceInfoLine2.billingAddress1 = address.locality
      this.inputData.invoiceInfoLine2.billingAddress2 = address.street
    },
    // 受取人の郵便番号自動入力
    getAddressFromRecipientPostalCode(address, recipientInfo) {
      recipientInfo.recipientRegion = countryUtil.getRegionInfoByName(
        recipientInfo.country.value,
        address.region
      )
      recipientInfo.recipientAddress1 = address.locality
      recipientInfo.recipientAddress2 = address.street
    },
    async init() {
      await this.getCustomerCategoryList()
      await this.getStorageList()

      const formatData = { ...this.customerData }
      // 新規登録の際に「表示する」項目のダイアログ初期値をtrueで設定
      if (Object.keys(formatData).length === 1) {
        formatData.isEnabled = true
      }
      formatData.phone = {
        countryCode: this.setCountryCallingCode(
          this.customerData.phoneNumberCountryId
        ),
        phoneNumber: this.customerData.phoneNumber
      }
      formatData.billingPhone = {
        countryCode: this.setCountryCallingCode(
          this.customerData.billingPhoneNumberCountryId
        ),
        phoneNumber: this.customerData.billingPhoneNumber
      }
      formatData.billingAddressCountry = this.setCountryId(
        this.customerData.billingAddressCountryId
      )
      formatData.billingRegion = countryUtil.getRegionInfo(
        this.customerData.billingAddressCountryId,
        this.customerData.billingRegionId
      )

      // recipientsをフォーマットした新たな配列を作成
      if (this.customerData.recipients) {
        formatData.recipients = this.customerData.recipients.map((ele) => {
          return {
            recipientId: ele.recipientId,
            name: ele.name,
            organizationName: ele.organizationName,
            note: ele.note,
            postalCode: ele.postalCode,
            address1: ele.address1,
            address2: ele.address2,
            sortNumber: ele.sortNumber,
            recipientPhone: {
              countryCode: this.setCountryCallingCode(ele.phoneNumberCountryId),
              phoneNumber: ele.phoneNumber
            },
            recipientAddressCountry: this.setCountryId(ele.addressCountryId),
            recipientRegion: countryUtil.getRegionInfo(
              ele.addressCountryId,
              ele.regionId
            )
          }
        })
      }
      const formatRecipientList = formatData.recipients
        ? formatData.recipients.map((ele) => {
            return {
              recipientInfoLine1: {
                recipientName: ele.name,
                recipientOrganizationName: ele.organizationName,
                recipientPhone: ele.recipientPhone,
                recipientSortNumber: ele.sortNumber,
                recipientNote: ele.note
              },
              recipientInfoLine2: {
                country: ele.recipientAddressCountry,
                recipientPostalCode: ele.postalCode,
                recipientRegion: ele.recipientRegion,
                recipientAddress1: ele.address1,
                recipientAddress2: ele.address2
              }
            }
          })
        : []

      this.inputData = {
        customerId: formatData.customerId,
        customerInfoLine1: {
          rep: formatData.rep,
          alphabet: formatData.alphabet,
          organizationName: formatData.organizationName,
          sectionName: formatData.sectionName,
          customerCategoryId: formatData.customerCategoryId,
          paymentCriteria: formatData.paymentCriteria,
          rateAccount: formatData.rateAccount,
          autoShipStorageId: formatData.autoShipStorageId
        },
        customerInfoLine2: {
          phone: formatData.phone,
          mailAddress: formatData.mailAddress,
          wechatId: formatData.wechatId,
          shopName: formatData.shopName,
          url: formatData.url,
          customerNote: formatData.customerNote,
          isEnabled: formatData.isEnabled
        },
        invoiceInfoLine1: {
          billingOrganizationName: formatData.billingOrganizationName,
          billingSectionName: formatData.billingSectionName,
          billingName: formatData.billingName,
          billingPhone: formatData.billingPhone
        },
        invoiceInfoLine2: {
          country: formatData.billingAddressCountry,
          billingPostalCode: formatData.billingPostalCode,
          billingRegion: formatData.billingRegion,
          billingAddress1: formatData.billingAddress1,
          billingAddress2: formatData.billingAddress2
        },
        recipientList: formatRecipientList
      }

      this.pageData = [
        {
          title: 'payment.payment_customer-info',
          name: 'customerInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.input_billing-info',
          name: 'invoiceInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.input_recipient-list',
          name: 'recipientInfo',
          subText: 'common.input_add-recipient',
          items: [],
          itemKey: ''
        }
      ]
      // ネクストエンジン連携用店舗フラグ更新
      this.inputData.isNeShop = formatData.neShopId ? true : false
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.customerId
        this.inputData.neShopId = this.customerData.neShopId
      }
      const success = this.editMode
        ? await this.editCustomer(this.inputData)
        : await this.registerCustomer(this.inputData)

      if (success) {
        // 都道府県がStringで追加された場合用に国マスタを再度取得
        this.getCountryListFromApi()
        this.$emit('success')
      }
    },
    getRecipientMaxSortNumber() {
      let recipientMaxSortNumber = 0
      const sortNumberList = this.inputData.recipientList.map((ele) => {
        return ele.recipientInfoLine1.recipientSortNumber
      })
      if (sortNumberList.length) {
        recipientMaxSortNumber = Math.max(...sortNumberList)
      }
      return recipientMaxSortNumber
    },
    // 受取人追加ボタンの処理
    addRecipientInputForm() {
      this.inputData.recipientList.push({
        recipientInfoLine1: {
          recipientName: null,
          recipientPhone: {
            countryCode: this.getCountryCallingCodeJpFromState(),
            phoneNumber: null
          },
          recipientSortNumber: this.getRecipientMaxSortNumber() + 1,
          recipientNote: null
        },
        recipientInfoLine2: {
          country: this.getCountryJpFromState(),
          recipientPostalCode: null,
          recipientRegion: countryUtil.getRegionInfo(null),
          recipientAddress1: null,
          recipientAddress2: null
        }
      })
    },
    // 受取人削除ボタンの処理
    deleteRecipientInfo(recipientItem) {
      this.inputData.recipientList = this.inputData.recipientList.filter(
        (recipient) => {
          return recipient != recipientItem
        }
      )
    }
  },
  computed: {
    // 新しく追加したcomputedプロパティ
    dynamicItems() {
      // itemsを深いコピーして、元の定義に影響が出ないようにする
      const newItems = JSON.parse(JSON.stringify(this.items))

      // isNeShopがtrueの場合のみ、autoShipStorageの定義を配列の末尾に追加
      if (this.inputData.isNeShop) {
        newItems.customerInfoLine1.push(this.autoShipStorageItem)
      }

      return newItems
    },
    recipients() {
      return this.inputData.recipientList.map((recipient) => {
        return {
          sortNumber: recipient.recipientInfoLine1.recipientSortNumber
        }
      })
    },
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.deleteItemCol {
  border-left: 1px solid #d8d8d8;
}
</style>
